import React, { FunctionComponent } from "react";
import WizardContainer, { WizardProps } from "../../containers/Wizard";
import { ADDRESS_PATH, STATE_PATH } from "../../routing/paths";
import FillOrigamiStep from "../FillOrigamiStep";

const CITY_SPELL_NAME = "city";

const FillOrigamiStepProps = {
  previous: ADDRESS_PATH,
  next: STATE_PATH,
  question: "In which <%= target %> is this located",
  target: "city",
  spellName: CITY_SPELL_NAME,
  placeholder: "Austin",
  required: false
};

export const CityStep: FunctionComponent<WizardProps> = (props: WizardProps) => (
  <FillOrigamiStep wizard={props} {...FillOrigamiStepProps} />
);

export default WizardContainer(CityStep);
